export default "__VITE_ASSET__omHJl_7J__"